import React from 'react'
import Body5 from '../body/Body5';
import Body6 from '../body/Body6';
import Body7 from '../body/Body7';
import Body from '../body/Body';
import Body1 from '../body/Body1';
import Body2 from '../body/Body2';
import Body3 from '../body/Body3';
import Body4 from '../body/Body4';
import Footers from '../footers/Footers';
import Headers from '../headers/Headers';
import FooterCall from '../footers/FooterCall';

const Home = () => {
  return (
    <>
    
      <Headers/>
      <Body/>
      <Body1/>
      <Body2/>
      <Body3/>
      <Body4/>
      <Body5/>
      <Body6/>
      <Body7/>
      <Footers/>
      <FooterCall/>
    </>
  )
}

export default Home
